import { memo } from 'react';
import { CardData } from '../../../../../types';
import { ColorPicker } from './ColorPicker';

interface ColorPickersSectionProps {
    cardNum: 1 | 2;
    data: CardData;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: string) => void;
}

export const ColorPickersSection = memo(({
    cardNum,
    data,
    disabled,
    onChange,
}: ColorPickersSectionProps) => (
    <div className="card-colors-section">
        <h5 className="colors-label">Card Colors</h5>
        <div className="colors-row">
            <ColorPicker
                cardNum={cardNum}
                label="Title Color"
                field="titleColor"
                targetIdSuffix="title"
                value={data.titleColor}
                disabled={disabled}
                onChange={onChange}
            />
            <ColorPicker
                cardNum={cardNum}
                label="Subtitle Color"
                field="subtitleColor"
                targetIdSuffix="subtitle"
                value={data.subtitleColor}
                disabled={disabled}
                onChange={onChange}
            />
            <ColorPicker
                cardNum={cardNum}
                label="Button Color"
                field="btnColor"
                targetIdSuffix="btnText"
                value={data.btnColor}
                disabled={disabled}
                onChange={onChange}
            />
        </div>
    </div>
));
